export const HERO_IMAGE = "/kuvat/poytaryhmat-ikkunat.jpg";

export const GALLERY = [
  {
    url: "/kuvat/juhlatila-yleiskuva.jpg",
    alt: "Yleiskuva Hengähdyksen juhlatilasta Porvoossa: ruokapöydät, avokeittiö ja sohvaryhmä",
  },
  {
    url: "/kuvat/oleskelutila-nojatuolit.jpg",
    alt: "Hengähdyksen oleskelutila Porvoossa: vaaleanvihreät nojatuolit, puinen sohvapöytä ja viherkasvit",
  },
  {
    url: "/kuvat/sauna.jpg",
    alt: "Vaalea puinen sauna noin 10 hengelle, kiuas ja kaksitasoiset lauteet Hengähdyksen saunatilassa Porvoossa",
  },
  {
    url: "/kuvat/keittio.jpg",
    alt: "Hyvin varusteltu valkoinen avokeittiö ja ruokailuryhmä Hengähdyksen juhlatilassa",
  },
  {
    url: "/kuvat/astiasto-lasit.jpg",
    alt: "Viini- ja juomalaseja sekä lautasia keittiön kaapissa — astiasto 24 hengelle",
  },
  {
    url: "/kuvat/pitka-poyta-ryijy.jpg",
    alt: "Pitkä juhlapöytä kymmenelle hengelle ja ryijy seinällä Hengähdyksen tilassa",
  },
  {
    url: "/kuvat/oleskelutila-tv.jpg",
    alt: "Sohvaryhmä, smart TV ja puinen sohvapöytä kodikkaassa oleskelutilassa",
  },
  {
    url: "/kuvat/astiasto-astiat.jpg",
    alt: "Kahvikupit, kulhot ja lautaset valmiina juhliin — astiasto 24 hengelle",
  },
  {
    url: "/kuvat/ruokapoyta.jpg",
    alt: "Valkoinen ruokapöytä ja tuolit vuokrattavassa juhlatilassa Porvoon Pappilanmäellä",
  },
  {
    url: "/kuvat/joogatila.jpg",
    alt: "Joogamatot ja viltit valmiina hyvinvointihetkeen valoisassa salissa — joogatila Porvoossa",
  },
  {
    url: "/kuvat/juhlatila-kukat.jpg",
    alt: "Katetut pöydät kukkakimppuineen ja avokeittiö Hengähdyksen juhlatilassa Porvoossa",
  },
  {
    url: "/kuvat/oleskelutila-iltavalo.jpg",
    alt: "Oleskelutilan sohvaryhmä, smart TV ja lämmin iltavalaistus Hengähdyksessä",
  },
  {
    url: "/kuvat/sauna-lauteet.jpg?v=2",
    alt: "Hengähdyksen saunan lauteet ja kiuas valmiina löylyihin",
  },
  {
    url: "/kuvat/kukkakimppu.jpg",
    alt: "Kukkakimppu valkoisella juhlapöydällä — juhlatila valmiina vieraille",
  },
];

export const PARTNERS = [
  {
    name: "Sanervattaren Sauna",
    url: "https://www.sanervattarensauna.fi/",
    domain: "sanervattarensauna.fi",
    logo: "/kuvat/sanervattaren-logo.webp",
    text: "Perinteisiä saunahoitoja, vihtahoitoja ja saunotuksia Porvoon Kråkössä meren äärellä. Haluatko juhliisi tai hyvinvointipäivääsi ohjatun saunaelämyksen? Suvi hoitaa homman.",
  },
  {
    name: "Catering Henriksson",
    url: "https://www.cateringhenriksson.fi/",
    domain: "cateringhenriksson.fi",
    logo: "/kuvat/catering-henriksson-logo.svg",
    text: "Catering ja pitopalvelut Porvoossa. Räätälöidyt tarjoilut asiakaslähtöisesti jokaiseen juhlaan — herkulliset ruoat suoraan Hengähdyksen pöytään.",
  },
];

export const USE_CASES = [
  {
    title: "Juhlat",
    text: "Ristiäiset, rippijuhlat, valmistujaiset ja muistotilaisuudet — lämminhenkinen tila pienille juhlille.",
    image: "/kuvat/pitka-poyta-ryijy.jpg",
    alt: "Katettava pitkä pöytä pienille juhlille Hengähdyksen juhlatilassa",
  },
  {
    title: "Yritykset ja ryhmät",
    text: "Kokoukset, tiimipäivät ja pienet tilaisuudet rauhallisessa ympäristössä.",
    image: "/kuvat/keittio.jpg",
    alt: "Avokeittiö ja pöytäryhmä kokoukselle ja koulutukselle kokoustilassa Porvoossa",
  },
  {
    title: "Koulutukset ja hyvinvointitapahtumat",
    text: "Muuntuva tila koulutuksiin, työpajoihin ja työhyvinvointipäiviin — kalustus järjestyy tilaisuutesi mukaan.",
    image: "/kuvat/joogatila.jpg",
    alt: "Joogamatot aseteltuna valoisaan saliin — tila muuntuu hyvinvointipäivän harjoituksiin",
  },
  {
    title: "Saunaillat",
    text: "Rentouttavat illat oman porukan kesken — sauna, sohvat ja hyvä seura.",
    image: "/kuvat/sauna.jpg",
    alt: "Vaalea puinen sauna ja kiuas saunaillan rentoutumiseen Hengähdyksessä",
  },
];

export const FAQ = [
  {
    q: "Kuinka monelle hengelle tila sopii?",
    a: "Juhlatilaa on 60 m² ja kokonaistilaa noin 95 m². Pöytäpaikat ja astiasto löytyvät 24 hengelle, ja saunaan mahtuu kerrallaan noin 10 henkeä.",
  },
  {
    q: "Mitä hintaan sisältyy?",
    a: "Hintaan sisältyy koko tilan käyttö: oleskelutila, hyvin varusteltu avokeittiö, astiasto ja smart TV. Sauna lämpiää lisähintaan 50 €.",
  },
  {
    q: "Milloin tila on vuokrattavissa?",
    a: "Tila on vuokrattavissa arki-iltaisin sekä viikonloppuisin (pe–su). Vakiotuntivuorot ovat sovittavissa erikseen.",
  },
  {
    q: "Sopiiko tila koulutuksiin ja hyvinvointipäiviin?",
    a: "Kyllä — tila muuntuu helposti koulutuksiin, työpajoihin ja hyvinvointipäiviin. Käytettävissä on tarvittaessa myös pelejä, luovia materiaaleja ja joogamattoja.",
  },
  {
    q: "Voiko tilaan tuoda omat tarjoilut?",
    a: "Kyllä, omat tarjoilut ovat tervetulleita. Hyvin varusteltu avokeittiö ja astiasto 24 hengelle ovat käytössäsi.",
  },
  {
    q: "Miten varaus tehdään?",
    a: "Täytä varauskysely sivun lopussa tai soita 050 341 6253. Vastaamme yleensä saman päivän aikana ja vahvistamme vapaan ajan.",
  },
  {
    q: "Missä tila sijaitsee?",
    a: "Osoite on Itäinen Pitkäkatu 25 B, 06100 Porvoo — Pappilanmäellä, kävelymatkan päässä Porvoon Vanhasta kaupungista.",
  },
];

export const PRICING = [
  { title: "Arki-ilta", detail: "klo 17–22", price: "150 €" },
  { title: "Pe, la tai su", detail: "1 päivä", price: "300 €" },
  { title: "Viikonloppu", detail: "2 päivää", price: "500 €" },
  { title: "Koko viikonloppu", detail: "pe–su", price: "600 €" },
];

export const CONTACT = {
  name: "Sari Saariaho",
  phone: "050 341 6253",
  phoneHref: "tel:+358503416253",
  email: "sari.saariaho@gmail.com",
  instagram: "https://www.instagram.com/tilajasauna",
  instagramHandle: "@tilajasauna",
  address: "Itäinen Pitkäkatu 25 B, 06100 Porvoo",
};
